import Chip from '@/components/UI/Chip/Chip';
import { _isNil, _notNil } from '@/littledash';
import type { SendBundleValidationResult } from '@/model/Agent.model';
import type { FC } from 'react';
import SendOmissionNotice from './SendOmissionNotice';
import { aiUseLabelOf, omissionOf } from './sendReport';

interface SendReportOverviewProps {
  result: SendBundleValidationResult;
  testId?: string;
}

/**
 * The top of a SEND bundle report: whether Benchling In Vivo AI took part, and the whole-report
 * omission (the per-file and cross-domain sections announce their own). Renders nothing for a result
 * stored before either was recorded.
 */
const SendReportOverview: FC<SendReportOverviewProps> = ({ result, testId = 'invivo-send-validator__overview' }) => {
  const aiUse = aiUseLabelOf(result.run_metadata);
  if (_isNil(aiUse) && _isNil(result.report)) {
    return null;
  }
  return (
    <div data-test-component="SendReportOverview" data-testid={testId}>
      {_notNil(aiUse) && (
        <div data-test-element="ai-use" data-test-key={aiUse.key}>
          <Chip title={aiUse.text} colour={aiUse.key === 'without_ai' ? 'blue' : 'gray'} />
        </div>
      )}
      {_notNil(result.report) && (
        <SendOmissionNotice
          omission={omissionOf(result.report.summary, result.report.advisory_counts)}
          testId="invivo-send-validator__report-omission"
        />
      )}
    </div>
  );
};

export default SendReportOverview;
